var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { action, observe, makeObservable } from 'mobx';
import { AttachedActionTrait } from '../../../trait/attachedspecific/AttachedActionTrait';
export class HookerTraitActive {
    parent;
    lifeCycle;
    constructor(parent) {
        makeObservable(this);
        this.parent = parent;
    }
    get app() {
        return this.parent.app;
    }
    nodesDidChange({ oldValue, newValue }) {
        const added = newValue.filter(x => !oldValue.includes(x));
        const removed = oldValue.filter(x => !newValue.includes(x));
        this.notifyBecomeActive(added);
        this.notifyBecomeInActive(removed);
    }
    notifyBecomeActive(added) {
        added.forEach(at => {
            if (at.key === 'onTraitBecomeActive' && at instanceof AttachedActionTrait) {
                at.fireEvent();
            }
        });
    }
    notifyBecomeInActive(removed) {
        removed.forEach(at => {
            if (at.key === 'onTraitBecomeInactive' && at instanceof AttachedActionTrait) {
                at.fireEvent();
            }
        });
    }
    enableHook() {
        if (!this.lifeCycle) {
            // handle double enables
            this.notifyBecomeActive(this.app.importingTree.allActiveTraits);
            this.lifeCycle = observe(this.app.importingTree, 'allActiveTraits', this.nodesDidChange);
        }
    }
}
__decorate([
    action.bound
], HookerTraitActive.prototype, "nodesDidChange", null);
__decorate([
    action.bound
], HookerTraitActive.prototype, "notifyBecomeActive", null);
__decorate([
    action.bound
], HookerTraitActive.prototype, "notifyBecomeInActive", null);
__decorate([
    action.bound
], HookerTraitActive.prototype, "enableHook", null);
